import { createStyles } from "@busbud/design-system-components/dist/styles/createStyles";

export const useStyles = createStyles(({ theme }) => {
  const { colors, spacing } = theme.busbud;

  return {
    chip: {
      display: "flex",
      flexWrap: "wrap",
      borderRadius: spacing(1.5),
      backgroundColor: colors.palette.teal.muted[50],
      borderColor: "transparent"
    },
    icon: {
      marginLeft: "-10px",
      color: colors.palette.teal.regular[500],
      flexShrink: 0
    },
    subtext: {
      color: colors.palette.teal.muted[800],
      fontWeight: 500
    },
    link: {
      fontWeight: 500
    },
    footer: {
      width: "100%",
      marginTop: spacing(3)
    }
  };
});
